import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Empty pages you still have to fill in', 'Hundreds of drills with no order between them', 'Free plans that stop at one practice', 'Hours of video to watch before you can plan', 'You still decide what to run on Tuesday'];
const withIt = ['A practice for every day of the season, in order', '300 pages of clocked, two-track practices', 'Rookie and Returner tracks on one clock for mixed rooms', 'One payment — no subscription', 'Open the practice and run it'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-297" data-mp="297qovf0g6w2z">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-298" data-mp="295e7p42ikpqz">
        <div className="text-center" data-id="element-299" data-mp="2d799sas9r75t">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-300" data-mp="30yeounqdxvf2">
            Why this isn&apos;t another planner
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-301" data-mp="35pwptbserw01">
            Blank planners vs{' '}
            <span className="text-coral-deep" data-id="element-302" data-mp="1oh1nqppoz7f0">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-303" data-mp="234wjkeyzxrwb">
            Most tools for wrestling coaches sell you empty pages or a catalog of
            drills. Writing it down was never the hard part — knowing what to
            run today, tomorrow and next week, with a mixed room, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-cream-dark" data-id="element-304" data-mp="2m3s9he3tnk4c">
          <div className="bg-cream px-3.5 py-4 sm:p-6" data-id="element-305" data-mp="2h578hcgqwweu">
            <h3 className="font-display text-base font-semibold text-ink-soft sm:text-xl" data-id="element-306" data-mp="2h5qqsuab5mte">
              A blank planner or a drill catalog
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-307" data-mp="mrg5gvsx9asd">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-308" data-mp="2mtpd4csdx185">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-309" data-mp="2ru3ljvxwed6p">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-310" data-mp="30sp43r3dds7h" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-plum px-3.5 py-4 text-white sm:p-6" data-id="element-311" data-mp="3ap0eucnba9zt">
            <h3 className="font-display text-base font-semibold text-gold sm:text-xl" data-id="element-312" data-mp="3fj4m6x0hok1f">
              Wrestling Practice Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-313" data-mp="3jl9i62eetsr8">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-314" data-mp="3ogf2iws5yzd7">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-315" data-mp="7hq8rfwqitok">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-316" data-mp="2j56zc1u41y0" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}